import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PromotionRoutingModule } from './promotion-routing.module';
import { PromotionComponent } from './promotion.component';
import { ProductListingComponent } from './components/product-listing/product-listing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { RatingModule } from 'ngx-bootstrap/rating';
import { NgxNumberSpinnerModule } from '../ngx-number-spinner/ngx-number-spinner.module';


@NgModule({
  declarations: [PromotionComponent, ProductListingComponent],
  imports: [
    CommonModule,
    PromotionRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgcCookieConsentModule,
    RatingModule.forRoot(),
    NgxNumberSpinnerModule
  ]
})
export class PromotionModule { }
